import { getModelHelpers, InferConstructorArgTypes, InferReadTypes } from '../../models/Model';
import { TypeArgType, typeFromJson } from '../../transforms/models/Types';
import { ArgTypes } from '../../utils/ArgValidation';
import { $TSFixMe } from '../../utils/typescript';

// com.tamr.transform.models.functions.Varargs
class Varargs extends getModelHelpers({
  name: { type: ArgTypes.string },
  type: { type: TypeArgType },
  distinct: { type: ArgTypes.bool },
  description: { type: ArgTypes.nullable(ArgTypes.string) },
}, 'Varargs')(({ RecordClass, typesAndDefaults, checkConstructorArgs, checkSetArgs }) => {
  type ConstructorArgTypes = InferConstructorArgTypes<typeof typesAndDefaults>;
  type ReadTypes = InferReadTypes<typeof typesAndDefaults>;
  return class VarargsRecord extends RecordClass {
    constructor(args: ConstructorArgTypes) {
      checkConstructorArgs(args);
      super(args);
    }
    set<T extends keyof ReadTypes>(name: T, value: ReadTypes[T]) {
      checkSetArgs(name, value);
      return super.set(name, value);
    }
  };
}) {
  static get argType() { return ArgTypes.instanceOf(this); }
  static fromJSON(json: $TSFixMe) {
    if (!json) return null;
    const { name, type, distinct, description } = json;
    return new Varargs({
      name,
      distinct,
      description,
      type: typeFromJson(type),
    });
  }
}

export default Varargs;
